export default "__VITE_ASSET__72dae7b5__"